<template>
    <form @submit.prevent="$parent.updateSettings">
        <b-card class="shadow">
            <h4 class="mb-0">{{ $t("Authentication") }}</h4>
            <p class="text-muted">
                {{
                    $t(
                        "Configure registration, social login and related 3rd party integrations"
                    )
                }}.
            </p>
            <div class="row mt-3">
                <div class="col-md-8">
                    <div class="form-group">
                        <toggle-button
                            :sync="true"
                            color="#3a1143"
                            id="registration_to_display"
                            v-model="$parent.settings.registration_to_display"
                        />
                        <label for="">{{
                            $t("Enable user registration")
                        }}</label>
                        <small class="form-text text-muted"
                            >{{
                                $t(
                                    "Allow users to register their account directly from the authentication page"
                                )
                            }}.</small
                        >
                    </div>
                    <!-- <div class="form-group">
            <toggle-button
              :sync="true"
              color="#3a1143"
              id="app_register"
              v-model="$parent.settings.app_register"
            />
            <label class="ml-2" for="app_register">{{
              $t("Enable user registration")
            }}</label>
            <small class="form-text text-muted"
              >{{
                $t(
                  "Allow users to register their account directly from the authentication page"
                )
              }}.</small
            >
          </div> -->
                    <div class="form-group">
                        <toggle-button
                            :sync="true"
                            color="#3a1143"
                            id="display_unverified_user_alert"
                            v-model="$parent.settings.unverified_user_alert"
                        />
                        <label class="ml-2" for="app_register">{{
                            $t("Display unverified user alert")
                        }}</label>
                        <small class="form-text text-muted"
                            >{{
                                $t(
                                    "Displays the alert that the user has not verified the account"
                                )
                            }}.</small
                        >
                    </div>
                    <div class="form-group">
                        <label>{{ $t("Default role") }}</label>
                        <b-form-select
                            :options="roles"
                            id="default_role"
                            plain
                            text-field="name"
                            v-model="$parent.settings.default_role"
                            value-field="id"
                        />
                        <small class="form-text text-muted"
                            >{{
                                $t(
                                    "Role that is assigned to a user on the registration page"
                                )
                            }}.</small
                        >
                    </div>

                    <div class="form-group">
                        <label
                            >Área de uso exclusivo para Administradores</label
                        >
                    </div>

                    <div class="form-group">
                        <label for="app_suporte_url">{{
                            $t("URL do Sistema de Suporte")
                        }}</label>
                        <input
                            class="form-control"
                            id="app_suporte_url"
                            required
                            type="text"
                            v-model="$store.state.settings.app_suporte_url"
                        />
                    </div>

                    <div class="form-group">
                        <label for="app_suporte_email">{{
                            $t("E-mail")
                        }}</label>
                        <input
                            class="form-control"
                            id="app_suporte_email"
                            type="text"
                            v-model="$store.state.settings.app_suporte_email"
                        />
                        <small class="form-text text-muted"
                            >E-mail da Cidade no Sistema de Suporte.</small
                        >
                    </div>

                    <div class="form-group">
                        <label for="app_suporte_password">{{
                            $t("Senha")
                        }}</label>
                        <input
                            class="form-control"
                            id="app_suporte_password"
                            type="password"
                            v-model="$store.state.settings.app_suporte_password"
                        />
                        <small class="form-text text-muted"
                            >Senha da Cidade no Sistema de Suporte.</small
                        >
                    </div>

                    <div class="form-group">
                        <label for="dias_validade_senha">Validade das Senhas dos Usuários (dias)</label>
                        <input
                            class="form-control"
                            id="dias_validade_senha"
                            type="number"
                            min="1"
                            v-model="$parent.settings.dias_validade_senha"
                        />
                    </div>

                    <div class="form-group">
                        <toggle-button
                            :sync="true"
                            color="#3a1143"
                            id="password_reset"
                            v-model="$parent.settings.password_reset"
                        />
                        <label for="password_reset">Habilitar experição de senha</label>
                        <small class="form-text text-muted"
                            >Habilitar ou desabilitar a expiração de senha dos usuários.</small
                        >
                    </div>
                </div>
            </div>
            <button
                class="btn btn-success btn-submit m-0"
                data-style="zoom-in"
                type="submit"
            >
                <i class="mdi mdi-content-save" />
                {{ $t("Update") }}
            </button>
        </b-card>
    </form>
</template>

<script>
export default {
    name: "Authentication",
    data() {
        return {
            roles: [],
        };
    },
    mounted() {
        this.getRoles();
    },
    methods: {
        // Get roles list
        getRoles() {
            // Get all settings values
            axios.get("api/dashboard/settings/roles").then((response) => {
                this.roles = response.data.data;
            });
        },
    },
};
</script>
